var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('TypeformNPS'),_c('PremiumModal'),_c('navbar'),_c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('sidebar'),_c('main-container')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }